export default {
    months: {
        one: 'месяц', 
        few: 'месяца', 
        many: 'месяцев', 
        other: 'месяцев',
    }
};